import React from "react";
import classNames from "classnames/bind";

// assets
import { AeroplaneIcon } from "src/assets/icons";

import styles from "./Loader.module.scss";
const cx = classNames.bind(styles);

const Loader = () => {
  return (
    <div className={cx("loader-root")}>
      <span>
        <AeroplaneIcon />
      </span>
    </div>
  );
};

export default Loader;
